import React, { SVGProps } from 'react'
const SvgExpand = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M13.25 13.25v5.25a.75.75 0 1 1-1.5 0v-5.25H6.5a.75.75 0 1 1 0-1.5h5.25V6.5a.75.75 0 0 1 1.5 0v5.25h5.25a.75.75 0 0 1 0 1.5h-5.25Z"
    />
  </svg>
)
export default SvgExpand
